// src/services/auth.js

const auth = {
    isAuthenticated: false,
  
    // Simulate login by setting isAuthenticated to true
    login() {
      this.isAuthenticated = true;
      localStorage.setItem('isAuthenticated', 'true'); // Persist login status in localStorage
    },
  
    // Simulate logout by setting isAuthenticated to false
    logout() {
      this.isAuthenticated = false;
      localStorage.removeItem('isAuthenticated'); // Remove login status from localStorage
    },
  
    // Check if the user is authenticated
    checkAuth() {
      const authStatus = localStorage.getItem('isAuthenticated');
      this.isAuthenticated = authStatus === 'true';
      return this.isAuthenticated;
    },
  };
  
  export default auth;
  